import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { webClientFileDownload } from '../../core/web_client';
import { INVOICES_PATH } from '../../core/constants';
import { exportFile, extractErrorDataFromFile, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getInvoiceAction = createAsyncThunk(
    'inventory/getInvoiceAction',
    async (invoiceNumber, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClientFileDownload.get(`${ INVOICES_PATH }?invoiceNumber=${ invoiceNumber }`);
            const fileName = response.headers['content-disposition']?.split('filename=')[1]?.replaceAll('"', '');
            exportFile(extractResponseData(response), fileName ? fileName : 'faktura.pdf');
            return fulfillWithValue();
        } catch (error) {
            const response = await extractErrorDataFromFile(extractResponseData(error?.response));
            return rejectWithValue(response);
        }
    }
);

const getInvoiceSlice = createSlice({
    name: 'getInvoiceSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getInvoiceAction.pending, () => STATE__API__STARTED);
        builder.addCase(getInvoiceAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getInvoiceAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getInvoiceState = (state) => state.inventory.getInvoice;
export default getInvoiceSlice.reducer;
